import { gql } from '@apollo/client';

export const WORKPLACE_MEMBERS = gql`
	query WorkplaceMembers(
		$fulltext: String
		$userId: UUID
		$workplaceIds: [UUID]
	) {
		workplaceMembers(
			fulltext: $fulltext
			userId: $userId
			workplaceIds: $workplaceIds
		) {
			data {
				__typename
				id
				workplace {
					id
					name
					fullName
					internalName
					doctorDisplayName
				}
			}
		}
	}
`;
